import { styled } from '@mui/material';

export const FieldsContainer = styled('div')`
  padding: 12px 0 0 36px;
  border-top: ${({ theme }) => `1px solid ${theme.colors.primary[30]}`};
  margin-top: 12px;
`;
